import { Link, NavLink, Outlet } from "react-router-dom";
import type { ReactNode } from "react";

import { AccountMenu } from "@/components/layout/AccountMenu";
import { BrandMark } from "@/components/layout/BrandMark";
import { cn } from "@/lib/cn";

const navItems = [
  { to: "/applications", label: "Applications" },
  { to: "/applications/new", label: "Create lead" },
];

export function AppShell({ children }: { children?: ReactNode }) {
  return (
    <div className="min-h-screen bg-[linear-gradient(180deg,#eef4fe_0%,#dfeafc_45%,#f6f8fc_100%)]">
      <header className="sticky top-0 z-20 border-b border-line bg-white shadow-[0_1px_0_rgba(14,11,20,0.04),0_4px_16px_rgba(4,83,233,0.06)]">
        <div className="mx-auto flex h-16 max-w-6xl items-center justify-between gap-4 px-4 sm:px-6">
          <div className="flex items-center gap-8">
            <Link to="/applications">
              <BrandMark withWordmark />
            </Link>
            <nav className="hidden items-center gap-1 sm:flex">
              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.to === "/applications"}
                  className={({ isActive }) =>
                    cn(
                      "rounded-lg px-3 py-2 text-sm font-medium transition",
                      isActive ? "bg-brand-soft text-brand" : "text-muted hover:text-ink",
                    )
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </nav>
          </div>

          <AccountMenu />
        </div>
      </header>

      <main className="mx-auto max-w-6xl px-4 py-8 sm:px-6">{children ?? <Outlet />}</main>
    </div>
  );
}
